import type { FeatureDefinitionGroup, FeatureExtractionVisibility } from '../feature-definition-types';

export type ScheduleRelativePath =
  | '/calendar'
  | '/availability'
  | '/eligibility-list'
  | '/request-history'
  | '/quickfill-history'
  | '/schedule-activity'
  | '/debug';

export const featureDefinition = {
  root: '/schedule',
  iconName: 'calendar',
  items: {
    '/calendar': {
      label: 'Calendar',
      trackingId: 'nav-schedule-calendar',
      description:
        'Visual scheduling interface for appointments, out of office events, and other time-based events. Offers day view only by provider.',
    },
    '/availability': {
      label: 'Availability Finder',
      trackingId: 'nav-schedule-availability',
      description: 'Preview the schedule for a selected service.',
    },
    '/eligibility-list': {
      label: 'Eligibility List',
      trackingId: 'nav-schedule-eligibility-list',
      description: 'View a list of upcoming appointments and their insurance eligibility data.',
    },
    '/request-history': {
      label: 'Request History',
      trackingId: 'nav-schedule-request-history',
      description:
        'Displays historical appointment requests and their statuses. Useful for follow-up and tracking patient inquiries.',
    },
    '/quickfill-history': {
      label: 'Waitlist History',
      trackingId: 'nav-schedule-quickfill-history',
      description:
        'Records the activity and notifications related to filling canceled appointment slots with new patients quickly.',
    },
    '/schedule-activity': {
      label: 'Schedule Activity',
      trackingId: 'nav-schedule-schedule-activity',
      description: 'Records and displays real-time activity and modifications made to the schedule.',
    },
    '/debug': {
      label: 'Debug',
      trackingId: 'nav-schedule-debug',
      description:
        'Access debugging tools and options for the scheduling module. Intended for developers and advanced users.',
    },
  },
} as const satisfies FeatureDefinitionGroup<'/schedule', 'calendar', ScheduleRelativePath>;

export const featureExtractionVisibility = {
  itemShowClassifications: {
    '/availability': 'runtime-conditional',
    '/eligibility-list': 'runtime-conditional',
    '/request-history': 'runtime-conditional',
    '/quickfill-history': 'runtime-conditional',
    '/schedule-activity': 'runtime-conditional',
    '/debug': 'runtime-conditional',
  },
} as const satisfies FeatureExtractionVisibility<ScheduleRelativePath>;
